import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const handleBackToHome = () => {
    window.location.hash = '';
    window.scrollTo(0, 0);
  };

  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <div className="nav-container">
          <div className="logo">
            <span className="logo-text" onClick={handleBackToHome} style={{ cursor: 'pointer' }}>PlayTiny</span>
          </div>
          <button className="back-button" onClick={handleBackToHome}>← Back to Home</button>
        </div>
      </nav>

      <div className="legal-content">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: April 4, 2026</p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to PlayTiny. We are committed to protecting your personal information and your right to privacy.
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use
              our mobile applications.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>2.1 Information You Provide</h3>
            <p>We may collect information that you provide directly to us, including:</p>
            <ul>
              <li>Name and contact information (email address, phone number)</li>
              <li>Account credentials and profile information</li>
              <li>Payment information for in-app purchases</li>
              <li>Communications with our support team</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>When you use our applications, we may automatically collect:</p>
            <ul>
              <li>Device information (device type, operating system, unique device identifiers)</li>
              <li>Usage data (application progress, achievements, in-application purchases)</li>
              <li>Log data (IP address, access times, app features accessed)</li>
              <li>Location data (if you grant permission)</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our applications and services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices, updates, and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Monitor and analyze trends and usage</li>
              <li>Personalize your user experience</li>
              <li>Detect, prevent, and address technical issues</li>
            </ul>
          </section>

          <section>
            <h2>4. Information Sharing and Disclosure</h2>
            <p>We do not sell your personal information. We may share your information in the following situations:</p>
            <ul>
              <li><strong>Service Providers:</strong> With third-party vendors who perform services on our behalf</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
              <li><strong>With Your Consent:</strong> When you have given us explicit permission</li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal information.
              However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot
              guarantee absolute security.
            </p>
          </section>

          <section>
            <h2>6. Children's Privacy</h2>
            <p>
              Our applications are not intended for children under the age of 13. We do not knowingly collect personal information
              from children under 13. If you are a parent or guardian and believe your child has provided us with personal
              information, please contact us immediately.
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>Depending on your location, you may have the following rights:</p>
            <ul>
              <li>Access to your personal information</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of your personal information</li>
              <li>Objection to processing of your information</li>
              <li>Data portability</li>
              <li>Withdrawal of consent</li>
            </ul>
          </section>

          <section>
            <h2>8. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our applications and hold certain information.
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
            </p>
          </section>

          <section>
            <h2>9. Advertising</h2>
            <p>
              We use third-party advertising companies, such as Google AdMob, to serve ads when you visit or use our applications. These companies may use information about your visits to our applications and other websites that are contained in web cookies and other tracking technologies in order to provide advertisements about goods and services of interest to you.
            </p>
            <p>
              Google, as a third-party vendor, uses cookies to serve ads on our applications. Google's use of advertising cookies enables it and its partners to serve ads to our users based on their use of our applications and other sites on the Internet. You may opt out of personalized advertising by visiting Google's Ads Settings or by visiting the Network Advertising Initiative opt-out page.
            </p>
          </section>

          <section>
            <h2>10. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new
              Privacy Policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>
            <ul>
              <li>Email: restofthings8@gmail.com</li>
              <li>Location: Hayathnagar, Telangana, India</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

